<template lang="pug">
v-app.Poppins
  v-container(grid-list-xl, fluid, Poppins)
    v-card.cardPadrao.br-10.pa-3
      v-layout(row, wrap)
        v-flex(lg12)
          .headline Notificações
      v-layout(row, wrap, v-if="loading")
        v-flex.text-xs-center
          v-progress-circular(:width="3", :size="40", color="primary", indeterminate)
      v-layout(row, wrap, v-else)
        v-flex(lg12)
          v-layout(row, wrap, v-if="!$root.notificacoes.length")
            v-flex.md12.text-xs-center.mt-5
              .headline.font-weight-light Não há notificações disponíveis.
          v-layout(row, v-else, wrap, v-for="(notificacao,index) in $root.notificacoes", :key="index")
            v-flex.md12
              v-card.notificacao.br-10
                v-card-title.md12.xs12.primary-title.title.pb-0 {{ notificacao.titulo + " "}}
                  .caption.ml-2.mt-2 {{ $dayjs(notificacao.data_envio).format('DD/MM/YYYY [às] HH:mm') }}
                v-card-text.md8.xs8.subtitle(style="color: rgba(17, 19, 18, 0.70);") {{ notificacao.mensagem }}
                v-card-actions.pt-0(v-if="notificacao.tipo_id == 2")
                  v-spacer
                  v-btn.btnVerMais.br-5(color="primary", small, :href="notificacao.url", target="_blank")
                    | Ver mais
                    i.fa.fa-arrow-up.iconSetaPraCima.ml-1
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  created () {
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted () {
    const vm = this;
    vm.onChangeEstabelecimento();
  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO NOTIFICAÇÕES', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado && !this.estabelecimentoSelecionado.cardapio_digital)
        this.getNotificacoes()
      else if(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital){
          this.$router.push({ path: '/delivery' });
      }
    },
    async getNotificacoes () {
      const vm = this;
      try {
        vm.loading = true;
        await vm.$root.getNotificacoes();
        vm.loading = false;
        vm.$root.setLastAccessNotification(vm.$dayjs().format());
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as notificações. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
  },
}
</script>

<style scoped>
.Poppins {
  font-family: "Poppins", "Roboto", "Helvetica" !important;
}
.Capitalize{
  text-transform: capitalize;
}
.br-5{
  border-radius: 5px !important;
}
.br-10{
  border-radius: 10px !important;
}

.bgcw{
  background-color: #fff;
}
.cardPadrao{
    box-shadow:none !important;
    background-color: #FAFAFA;
  }
  .headline{
    font-family: "Poppins", "Roboto", "Helvetica" !important;
  }
  .title{
    font-family: "Poppins", "Roboto", "Helvetica" !important;
    font-weight: 500 !important;
  }
  .notificacao{
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05) !important;
    border: 1px solid rgba(17, 19, 18, 0.08);
    background: rgba(50, 186, 114, 0.08);
  }
  .btnVerMais{
    box-shadow: none !important;
    color: #fff !important;
    text-transform: capitalize !important;
  }
  .iconSetaPraCima{
    font-size:12px;
    -moz-transform: translateY(-1px);
    -o-transform: translateY(-1px);
    -webkit-transform: translateY(-1px);
    transform: translateY(-1px) rotate(45deg);
  }
</style>
